import React from 'react';

const features = [
  {
    title: 'Less Time, Fewer Headaches',
    img: '/assets/img/landing-page/features/headache.webp',
    detail:
      'WellPay was created with the needs of lean HR teams at heart, giving them the tools and resources they need to deploy competitive compensation strategies that attract key talent to their organization and keep their current employees engaged across all compensation processes without the stress and headache of dated compensation programs.',
  },
  {
    title: 'On-Demand Guidance',
    img: '/assets/img/landing-page/features/guidance.webp',
    detail:
      "Creating a powerful compensation program is no small task. That's why our executive advisors are here to address compensation topics and concerns within each user's organization, allowing them to leverage the same industry insights trusted by Fortune 500 companies and cutting-edge startup operations.",
  },
  {
    title: 'Comprehensive Strategies',
    img: '/assets/img/landing-page/features/comprehensive-strategies.webp',
    detail:
      'Our mission is to support organizations with end-to-end compensation programs that integrate incentives programs and competitive salary structures with long-term growth in mind. WellPay is the one-stop total rewards destination your people team has been dreaming of.',
  },
];

function Features() {
  return (
    <div className="section mt-0">
      <div className="container" id="features">
        <div className="row">
          <div className="col-12 offset-0 col-lg-8 offset-lg-2 text-center">
            <h2>
              How We Power
              <br />
              Dynamic Compensation Programs
            </h2>
          </div>
        </div>
        {features.map((feature, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={`feature_${i}`}>
            {i % 2 === 0 && (
              <div className="row feature-row">
                <div className="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                  <div className="feature-text-container">
                    <h2>{feature.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: feature.detail }} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 offset-lg-1 offset-md-0 position-relative">
                  <img
                    alt={feature.title}
                    src={feature.img}
                    className="feature-image-right feature-image-charts position-relative"
                    loading="lazy"
                  />
                </div>
              </div>
            )}
            {i % 2 === 1 && (
              <div className="row feature-row">
                <div className="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                  <img
                    alt={feature.title}
                    src={feature.img}
                    className="feature-image-left feature-image-charts"
                    loading="lazy"
                  />
                </div>
                <div className="col-12 col-md-6 offset-md-0 col-lg-5 offset-lg-1 d-flex align-items-center order-1 order-md-2">
                  <div className="feature-text-container">
                    <h2>{feature.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: feature.detail }} />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Features;
